import { TrustSectionsEnum } from './trust-sections.enum';

export const TrustSectionsTitles = {
  [TrustSectionsEnum.Home]: 'Trust Home',
  [TrustSectionsEnum.Subscriber]: 'Subscriber (YOUR) information',
  [TrustSectionsEnum.TrustDetails]: 'Trust Details',
  [TrustSectionsEnum.TrustAssetsDetails]: 'Trust Assets Details',
  [TrustSectionsEnum.Documents]: 'Documents',
  [TrustSectionsEnum.Forms]: 'Forms',
  [TrustSectionsEnum.Taxes]: 'Taxes Details',
  [TrustSectionsEnum.BondSurety]: 'Bond/Surety Details',
  [TrustSectionsEnum.Notes]: 'Notes',
  [TrustSectionsEnum.Messages]: 'Messages',
} as const;
